module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d5f5febae78306a2394c6ba6768440de.png";